import { Outlet } from 'react-router-dom';

export default function Develop() {
  return <Outlet />;
}

